import axios from 'axios'
import { Toast } from "vant";
axios.defaults.headers["Cache-Control"] = 'no-cache';
export const baseURL = 'https://api.veiban.com'
export async function request(config) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      // baseURL,
      timeout: 20000
    });
    instance.interceptors.request.use(config => {
      const user = JSON.parse(localStorage.getItem('user'))
      console.log(config.url.indexOf(process.env.VUE_APP_OLD_VEIBAN_BHOST));
      config.headers.Authorization = config.url.indexOf(process.env.VUE_APP_OLD_VEIBAN_BHOST) > -1 ? user?.token : 'Bearer ' + user?.newToken;
      config.headers.tenantId = user?.tenantId || '';
      config.headers.deviceCategory = user?.deviceCategory || ''; // 协助审批
      config.headers.UUID = user?.UUID || ''; // 协助审批
      return config
    }, _error => {
      return Promise.reject('请求报错！')
    })

    instance(config).then(res => {
      resolve(res)
    }).catch(err => {
      if (err.message.includes('timeout')) {
        Toast('当前网络不佳！请重新操作');
        reject(err);
      } else {
        reject(err);
      }
    })
  })
}